import axios, { AxiosPromise } from 'axios';

// eslint-disable-next-line import/prefer-default-export
export const fetchProtectedImage = (url: string): AxiosPromise<Blob> =>
  axios.get(url, {
    responseType: 'blob'
  });
